export default __webpack_public_path__ + "static/media/myimage.037fa250.png";